import React, { lazy, Component } from 'react';
import { ArrowRight } from 'lucide-react';
// ============================================
// TEXTOS EDITABLES - Modifica estos textos directamente
// ============================================
const SECTION_TITLE = 'Proyectos que Hablan por Sí Mismos';
const SECTION_SUBTITLE = 'Transformaciones reales que superaron las expectativas de nuestros clientes';
const BEFORE_LABEL = 'ANTES';
const AFTER_LABEL = 'DESPUÉS';
const BUTTON_TEXT = 'Ver Portafolio Completo';
// ============================================
// PROYECTOS - Modifica solo 3 proyectos (ANTES y DESPUÉS)
// ============================================
const projects = [{
  before: 'https://cdn.magicpatterns.com/uploads/p7X8qAthCKRYTNX7DAcBZZ/GERFAJ_-_CH_-_ANTES.png',
  after: 'https://cdn.magicpatterns.com/uploads/9bmKLy2FA1BCYYequ7yZgH/GERFAJ_-_CH_-_001.png',
  city: 'Bucaramanga',
  zone: 'Campo Hermoso',
  type: 'Residencial'
}, {
  before: 'https://cdn.magicpatterns.com/uploads/pRbkfXA4yCyXHiMZhm6kXZ/GERFAJ_-_A_-_SONESTA.jpg',
  after: 'https://cdn.magicpatterns.com/uploads/dWh1pj9avAugEZMWqucqKH/GERFAJ_-_D_-_SONESTA.jpg',
  city: 'Floridablanca',
  zone: 'Caracolí',
  type: 'Comercial'
}, {
  before: 'https://cdn.magicpatterns.com/uploads/qudeu4U2TBKZ4YRcxesXpD/GERFAJ_-_JIMFER_-_A_.jpg',
  after: 'https://cdn.magicpatterns.com/uploads/7mgPcbLc1BxWVdqVNKpsBw/GERFAJ_-_JIMFER_-_D.png',
  city: 'Bucaramanga',
  zone: 'San Alonso',
  type: 'Corporativo'
}];
export function PortfolioSection() {
  const handleWhatsApp = () => {
    // Track Lead event
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    const message = encodeURIComponent('Hola, AGENDAR ASESORÍA - 35% OFF');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  return <section className="bg-white py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-167">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-168">
        <div className="text-center mb-8 md:mb-16" data-id="element-169">
          <h2 className="text-[26px] md:text-[40px] font-bold text-[#1A1A1A] mb-4" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-170">
            {SECTION_TITLE}
          </h2>
          <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/60 font-normal max-w-2xl mx-auto" style={{
          lineHeight: '1.6'
        }} data-id="element-171">
            {SECTION_SUBTITLE}
          </p>
        </div>

        <div className="space-y-8 md:space-y-16 mb-8 md:mb-12" data-id="element-172">
          {projects.map((project, index) => <div key={index} className="space-y-4" data-id="element-173">
              {/* Before/After Images */}
              <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-174">
                {/* ANTES */}
                <div className="group" data-id="element-175">
                  <div className="relative rounded-3xl overflow-hidden aspect-[4/3]" data-id="element-176">
                    <img src={project.before} alt={`${project.city} - ${project.zone} - Antes`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" width="600" height="450" loading="lazy" decoding="async" data-id="element-177" />
                    <div className="absolute top-4 left-4 bg-[#6B7280] text-white px-4 py-2 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
                  lineHeight: '1',
                  letterSpacing: '0.08em'
                }} data-id="element-178">
                      {BEFORE_LABEL}
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A] via-transparent to-transparent opacity-60" data-id="element-179" />
                  </div>
                </div>

                {/* DESPUÉS */}
                <div className="group" data-id="element-180">
                  <div className="relative rounded-3xl overflow-hidden aspect-[4/3]" data-id="element-181">
                    <img src={project.after} alt={`${project.city} - ${project.zone} - Después`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" width="600" height="450" loading="lazy" decoding="async" data-id="element-182" />
                    <div className="absolute top-4 left-4 bg-[#E8621A] text-white px-4 py-2 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
                  lineHeight: '1',
                  letterSpacing: '0.08em'
                }} data-id="element-183">
                      {AFTER_LABEL}
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A] via-transparent to-transparent opacity-60" data-id="element-184" />
                  </div>
                </div>
              </div>

              {/* Shared Caption */}
              <div className="text-center space-y-2" data-id="element-185">
                <div className="flex items-center justify-center gap-2 text-[#1A1A1A]/60 text-[15px] md:text-[17px] font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-186">
                  <span data-id="element-187">{project.city}</span>
                  <span data-id="element-188">•</span>
                  <span data-id="element-189">{project.zone}</span>
                </div>
                <div className="inline-block bg-[#1A1A1A]/10 text-[#1A1A1A] px-3 py-1 rounded-full text-[11px] md:text-[12px] font-semibold uppercase" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-190">
                  {project.type}
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-191">
          <button onClick={handleWhatsApp} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-10 py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all shadow-2xl shadow-[#E8621A]/30 hover:scale-105 inline-flex items-center justify-center gap-3 min-h-[52px]" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-192">
            AGENDAR ASESORÍA - 35% OFF
          </button>
        </div>
      </div>
    </section>;
}